import { literal, union, UnionC, LiteralC } from "io-ts";

export const LiteralUnion = <T extends string | number | boolean>(values: readonly [T, T, ...T[]]): UnionC<[LiteralC<T>, LiteralC<T>, ...LiteralC<T>[]]> => {
    const vs = values;
    const literals = vs.map(v => literal(v));
    return union([literals[0], literals[1], ...literals.slice(2)]);
}